import { TranslationResourceProvider, TranslationNamespaces } from 'Roblox';
import angular from 'angular';

let forgotCredentials = angular
    .module("forgotCredentials", ["robloxApp", "modal", "captchaV2", "phoneValidation"])
    .config(['languageResourceProvider', function (languageResourceProvider) {
        const translationProvider = new TranslationResourceProvider();
        const resetPasswordResources = translationProvider.getTranslationResource('Authentication.ResetPassword');
        const controlsResources = translationProvider.getTranslationResource('CommonUI.Controls');
        languageResourceProvider.setTranslationResources([
          resetPasswordResources,
          controlsResources
        ]);
    }]);

export default forgotCredentials;


